import { gql } from '@apollo/client';

export const lienholderQuery = gql`
  query lienholder($state: String!, $slug: String!) @api(name: prs) {
    lienholder(state: $state, slug: $slug) {
      id
      slug
      display_name
      website_url
      double_tax
      phone_numbers {
        name
        phone_numbers
      }
      requirements_to_payoff_lease {
        direct_pay {
          value
        }
        include_sales_tax {
          value
        }
      }
      requirements_to_get_payoff {
        id
        options
        instruction_sets {
          type
          phone_number
          intro
          note
          instructions {
            text
            details
          }
        }
        get_payoff_methods {
          id
          call_as_tater_finance {
            value
          }
          conference_customer {
            value
          }
          request_customer_payoff {
            value
          }
          digital {
            value
          }
          auto_phone {
            value
          }
          phone {
            value
          }
        }
      }
      required_documents_to_payoff_lease {
        tater {
          value
        }
        send_payoff {
          value
        }
        titling {
          value
        }
        oem_odo {
          value
        }
        damage_disclosure {
          value
        }
      }
    }
  }
`;

export const lienholderRequirementsToGetPayoff = gql`
  query lienholderRequirementsToGetPayoff($slug: String!) @api(name: prs) {
    lienholderRequirementsToGetPayoff(slug: $slug) {
      id
      slug
      display_name
      website_url
      double_tax
      phone_numbers {
        name
        phone_numbers
      }
      requirements_to_get_payoff {
        id
        options
        instruction_sets {
          type
          phone_number
          intro
          note
          instructions {
            text
            details
          }
        }
      }
    }
  }
`;

export const allLienholdersQuery = gql`
  query allLienholders($make: String!) @api(name: prs) {
    allLienholders {
      id
      slug
      display_name
      logo_url
      enabled
      is_core
      aliases
      requirements_to_get_payoff {
        get_payoff_methods {
          digital {
            value
            options
          }
        }
      }
      probableLienholder(make: $make)
    }
  }
`;
